import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2024 Molly Butler Lodge & Restaurant. All rights reserved.</p>
        <p>Greer, Arizona • Established 1910</p>
      </div>
    </footer>
  );
};

export default Footer;